import React from "react";
import {
  FaSearch,
  FaFileExport,
  FaTimes,
} from "react-icons/fa";

const UserFilters = ({
  search,
  setSearch,
  roleFilter,
  setRoleFilter,
  statusFilter,
  setStatusFilter,
  roles,
  users = [],}) => {

  const exportCSV = () => {
    if (!users.length) {
      return;
    }
    const headers = [
      "Username",
      "First Name",
      "Last Name",
      "Email",
      "Mobile",
      "Role",
      "Status",
    ];
    const rows = users.map((user) => [
        user.username,
        user.firstName,
        user.lastName,
        user.email,
        user.mobileNo,
        user.roleId,
        user.is_active
          ? "Active"
          : "Inactive",
      ]
    );

    const csvContent = [headers,...rows,].map((row) => row.join(",")).join("\n");

    const blob = new Blob(
      [csvContent],
      {
        type: "text/csv",
      }
    );

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "users.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const clearFilters = () => {
    setSearch("");
    setRoleFilter("");
    setStatusFilter("all");
  };

  return (
    <div className="mb-5 rounded-xl bg-white p-4 shadow">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">

        {/* Search */}
        <div className="relative lg:col-span-5">
          <FaSearch
            className="absolute left-3 top-3 text-gray-400"
          />

          <input
            type="text"
            placeholder="Search username, email, mobile..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
            className="w-full rounded-lg border py-2 pl-10 pr-3 focus:border-[#F7525A] focus:outline-none"
          />
        </div>

        {/* Role Filter */}
        <div className="lg:col-span-3">
          <select
            value={roleFilter}
            onChange={(e) =>
              setRoleFilter(e.target.value)
            }
            className="w-full rounded-lg border px-3 py-2 focus:border-[#F7525A] focus:outline-none"
          >
            <option value="">
              All Roles
            </option>
            {roles.map((role) => (
                <option
                  key={role.roleId}
                  value={role.roleId}
                >
                  {role.roleName}
                </option>
              )
            )}
          </select>
        </div>

        {/* Status */}
        <div className="lg:col-span-2">
          <select
            value={statusFilter}
            onChange={(e) =>
              setStatusFilter(e.target.value)
            }
            className="w-full rounded-lg border px-3 py-2 focus:border-[#F7525A] focus:outline-none"
          >
            <option value="all">
              All Status
            </option>
            <option value="true">
              Active
            </option>
            <option value="false">
              Inactive
            </option>
          </select>
        </div>

        {/* Actions */}
         <div className="flex gap-2 lg:col-span-2">
 {/*         <button
            onClick={exportCSV}
            className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-green-600 px-3 py-2 text-white hover:bg-green-700"
          >
            <FaFileExport />
            Export
          </button>*/}
          <button
            title="Clear Filters"
            onClick={clearFilters}
            className="flex items-center justify-center rounded-lg border px-3 py-2 hover:bg-gray-100"
          >
            <FaTimes />
          </button>
        </div> 
      </div>
    </div>
  );
};

export default UserFilters;